import QaDisplayConfig = app.specialist.qa.interfaces.QaDisplayConfig
import TaskTypeEnum = Boo.Objects.Enums.TaskTypeEnum;
import QaCriteriaGroupEnum = Boo.Qa.QaCriteriaGroupEnum;
import QaCriteriaGroup = Boo.Qa.QaCriteriaGroup;
import { QaCriteriaDefinitionProperty } from '../enums/qa-criteria-definition-property';

export default class QaDisplayConfigFactory {
    public static create(internalTaskType: TaskTypeEnum, criteriaGroups: QaCriteriaGroup[]): QaDisplayConfig[] {
        let displayConfigs: QaDisplayConfig[];

        switch (internalTaskType) {
            case TaskTypeEnum.InternalTaskQaClassifiedBusinessListings:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ClassifiedBusinessListing]),
                        displayItem: QaCriteriaDefinitionProperty.Name,
                        showComment: false,
                        showTitle: false
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaLocalBusinessCitations:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.LocalBusinessCitation]),
                        displayItem: QaCriteriaDefinitionProperty.Name,
                        showComment: false,
                        showTitle: false
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaOnsiteBloggingReview:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteBloggingReviewAutoFail]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteBloggingReviewEditorsFeedback]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteBloggingReviewEditingQuality]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaOnsiteCopyReview:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteCopyReviewAutoFail]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteCopyReviewEditorsFeedback]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteCopyReviewEditingQuality]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                ];
                break;
            case TaskTypeEnum.InternalTaskQaPremiumMonthlyCampaignUpdate:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateDates])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateBranding])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateData])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateKwrRank])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateScreenShots])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateTables])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateGbp])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateSavedFormatting])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateClickTracking])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumMonthlyCampaignUpdateTicket])
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaPremiumPreliminaryAudit:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditBranding])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditExecutiveSummary])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditKeywords])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditGeneral])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditScreenshots])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditPreviousData])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumPreliminaryAuditReport])
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaProactiveUnderperformingKeyword:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaLaunchpad])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaGlobal])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaPageSpecific])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaSummaryandRecommendation])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaIncorrectItem]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaSpellingandGrammar])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.ProactiveUnderperformingKeywordQaNotesFilled])
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaPremiumBacklink:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkReportedCorrectly]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    }, {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkBlogPublisherQuality]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkClientLink]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkPublisher]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkArticleParagraph]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkTitle]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkNegativity]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkFillerContent]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkFormattingFlow]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkGrammarPunctuationTypos]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.PremiumBacklinkReviewsAuthority]),
                        displayItem: QaCriteriaDefinitionProperty.Points
                    }
                ];
                break;
            case TaskTypeEnum.InternalTaskQaOnsiteRecommendationReview:
                displayConfigs = [
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteRecommendationReviewStyleGuideStandards])
                    },
                    {
                        groups: this.filterGroups(criteriaGroups, [QaCriteriaGroupEnum.OnsiteRecommendationReviewGrammar])
                    }
                ];
                break;
            default:
                throw Error(`Cannot find QA display config for task type (${internalTaskType})`);
        }

        return displayConfigs.filter(x => x.groups.length !== 0);
    }

    private static filterGroups(groups: QaCriteriaGroup[], filterFor: QaCriteriaGroupEnum[]): QaCriteriaGroup[] {
        return groups.filter(x => filterFor.includes(x.QaCriteriaGroupEnum));
    }
}
